<div class="flex flex-col p-4 bg-gray-50">
  <div
    class="border border-solid rounded-lg border-gray-300 bg-white hover:bg-gray-50"
    (click)="onClick($event)"
  >
    <div>
      <img
        class="rounded-lg rounded-b-none w-full object-cover"
        [src]="ogImage"
      />
    </div>
    <div class="flex flex-col px-2">
      <div class="pt-2 pb-4">
        <span class="text-gray-500 text-sm">{{ domain }}</span>
      </div>
      <div class="py-1">
        <span>{{ ogTitle }}</span>
      </div>
      <div class="py-1">
        <span>
          <span class="text-gray-600 text-sm">{{ ogDescription }}</span>
        </span>
      </div>
    </div>
  </div>
</div>
